import Page from 'front/pages/Page/Page';
import Urls from 'django_js_front/reverse.js';
import * as _ from 'underscore';

import TopBar from 'front/components/Common/TopBar/TopBar';
import IllustrationItem from 'front/components/IllustrationComponents/IllustrationItem/IllustrationItem';
import IllustrationItemTemplate
from 'front/components/IllustrationComponents/IllustrationItem/IllustrationItemFrontendRendering.jinja';
import SearchItem from 'front/components/Common/SearchItem/SearchItem';
import SearchItemTemplate from 'front/components/Common/SearchItem/SearchItemFrontendRendering.jinja';


import { VIEWPORT_EVENTS } from '../../constants/Constants';
import axios from 'axios';

import './IllustrationsAuthor.less';
import * as Template from './IllustrationsAuthor.jinja';

const Selectors = {
    el: '.IllustrationsAuthor',
    onMoreButton: '.IllustrationsAuthor-more',
    wrapper: '.IllustrationsAuthor-wrapper',
    select: '.IllustrationsAuthor-select',
    selectWrapper: '.IllustrationsAuthor-select-wrapper',
    selectDescription: '.IllustrationsAuthor-select-description',
    selectPopup: '.IllustrationsAuthor-selectPopup',
    selectPopupWrapper: '.IllustrationsAuthor-selectPopup-wrapper',
    input: 'input[type="search"]',
    deleteButton: '.clear',
    searchItem: '.SearchItem.search',
    topBarFilters: '.TopBar-filters',
    tobBarFilterItem: '.TopBar-filtersItem',
    itemCaption: '.IllustrationItem-caption'
};


const BindFunctions = [
    'onMoreLinkClick',
    'onLoad',
    'onLoadPopup'
];

export default class IllustrationsAuthor extends Page {
    events() {
        return {
            [`${VIEWPORT_EVENTS.click} ${Selectors.onMoreButton}`]: this.onMoreLinkClick,
            [`${VIEWPORT_EVENTS.keyUp} ${Selectors.input}`]: this.onKeySearch,
            [`${VIEWPORT_EVENTS.click} ${Selectors.searchItem}`]: this.onItem,
            [`${VIEWPORT_EVENTS.click} ${Selectors.deleteButton}`]: this.onDeleteItem
        };
    }

    constructor(options = {}) {
        options.el = Selectors.el;
        options.VIEWS_TO_REGISTER = {
            'top-bar': { selector: '.TopBar', viewConstructor: TopBar },
            'illustration-item': { selector: '.IllustrationItem', viewConstructor: IllustrationItem },
            'search-item': { selector: '.SearchItem', viewConstructor: SearchItem }
        };
        options.template = Template;
        super(options);
        _.bindAll(this, BindFunctions);

        const splitUrl = window.location.pathname.split('/');
        this.urlParams = splitUrl[splitUrl.length - 2];
        this.$more = this.$(Selectors.onMoreButton);
        this.$moreContent = this.$(Selectors.wrapper);
        this.$selectPopup = this.$(Selectors.selectPopup);
        this.$selectPopupWrapper = this.$(Selectors.selectPopupWrapper);
        this.count = 0;
        this.query = [];
        this.query = Array.from(new Set(this.urlParams.split(',')));

        // closing the popup outside the element
        $(window.document).click(function (e) {
            if (!$(e.target).closest(Selectors.select).length) {
                $(Selectors.selectPopup).removeClass('open');
            }
        });

        axios.get(Urls['front:api:illustrations-search-page-tokens'](), {
            params: {
                loaded: this.count,
                slug: Array.from(new Set(this.query)).join(',')
            }
        }).then(response => {
            this.allCount = response?.data?.count;
            this.tokens = response?.data?.tokensList;
            this.onLoad(response?.data?.illustrationsList);

            this.tokens.forEach((item) => {
                if (item.translations[window.app.settings.language].name.length >= 35) {
                    this.$(Selectors.selectWrapper)
                        .prepend('<span data-id="' + item.slug + '">'
                            + item.translations[window.app.settings.language].name.substr(0, 35) + '...'
                            + '<span class="clear"></span>' + '</span>');
                } else {
                    this.$(Selectors.selectWrapper)
                        .prepend('<span data-id="' + item.slug + '">'
                            + item.translations[window.app.settings.language].name
                            + '<span class="clear"></span>' + '</span>');
                }

                this.$(Selectors.selectDescription)
                    .prepend('<span data-id="' + item.slug + '">'
                        + item.translations[window.app.settings.language].description
                        + '<span class="clear"></span>' + '</span>');
            });


            if (this.allCount > 40) {
                this.$more.removeClass('hidden');
            }
        });
    }

    onItem(e) {
        const $target = $(e.currentTarget);
        this.query.push($target.data('slug'));

        this.count = 0;
        this.$(Selectors.input).val('');
        this.$selectPopup.removeClass('open');
        this.$selectPopupWrapper.children().remove();

        axios.get(Urls['front:api:illustrations-search-page-tokens'](), {
            params: {
                loaded: this.count,
                slug: Array.from(new Set(this.query)).join(',')
            }
        }).then(response => {
            window.history.pushState({}, 'search', '');
            window.history.pushState({}, 'search',
                '?query=' + Array.from(new Set(this.query)).join(',')
                    .replaceAll(',', '&x20;'));

            this.$moreContent.children().remove();
            this.allCount = response?.data?.count;
            this.tokens = response?.data?.tokensList;
            this.onLoad(response?.data?.illustrationsList);

            this.$(Selectors.selectWrapper)
                .children()
                .remove();
            this.tokens.forEach((item) => {
                if (item.translations[window.app.settings.language].name.length >= 35) {
                    this.$(Selectors.selectWrapper)
                        .prepend('<span data-id="' + item.slug + '">'
                            + item.translations[window.app.settings.language].name.substr(0, 35) + '...'
                            + '<span class="clear"></span>' + '</span>');
                } else {
                    this.$(Selectors.selectWrapper)
                        .prepend('<span data-id="' + item.slug + '">'
                            + item.translations[window.app.settings.language].name
                            + '<span class="clear"></span>' + '</span>');
                }
                this.query.push(item.slug);
            });

            if (this.allCount > 40) {
                this.$more.removeClass('hidden');
            }
        });
    }

    onDeleteItem(e) {
        const $target = $(e.currentTarget).parent();
        $target.remove();

        this.query = this.query.filter((item) => {
            return (item !== $target.data('id'));
        });

        window.history.pushState({}, 'search', '');
        window.history.pushState({}, 'search',
            '?query=' + Array.from(new Set(this.query)).join(',')
                .replaceAll(',', '&x20;'));

        this.count = 0;
        axios.get(Urls['front:api:illustrations-search-page-tokens'](), {
            params: {
                loaded: this.count,
                slug: Array.from(new Set(this.query)).join(',')
            }
        }).then(response => {
            this.$moreContent.children().remove();
            this.allCount = response?.data?.count;
            this.tokens = response?.data?.tokensList;
            this.onLoad(response?.data?.illustrationsList);

            this.$(Selectors.selectWrapper)
                .children()
                .remove();
            this.tokens.forEach((item) => {
                if (item.translations[window.app.settings.language].name.length >= 35) {
                    this.$(Selectors.selectWrapper)
                        .prepend('<span data-id="' + item.slug + '">'
                            + item.translations[window.app.settings.language].name.substr(0, 35) + '...'
                            + '<span class="clear"></span>' + '</span>');
                } else {
                    this.$(Selectors.selectWrapper)
                        .prepend('<span data-id="' + item.slug + '">'
                            + item.translations[window.app.settings.language].name
                            + '<span class="clear"></span>' + '</span>');
                }
                this.query.push(item.slug);
            });

            if (this.allCount > 40) {
                this.$more.removeClass('hidden');
            }
        });
    }

    async onMoreLinkClick() {
        await axios.get(Urls['front:api:illustrations-search-page-tokens'](), {
            params: {
                loaded: this.count,
                slug: Array.from(new Set(this.query)).join(',')
            }
        }).then(response => {
            this.$more.addClass('isHide');
            this.onLoad(response?.data?.illustrationsList);
        });
    }

    onLoadPopup(data) {
        // collecting and rendering data for search
        if (data) {
            if (this.value) {
                this.$selectPopupWrapper.children().remove();
            }
            for (let i = 0; i <= data.length && data[i] !== undefined; i++) {
                let $moreItems = $(SearchItemTemplate.render({
                    item: data[i],
                    language: window.app.settings.language,
                    mods: 'search'
                }));

                this.$selectPopupWrapper.append($moreItems);
            }
        }
    }

    onLoad(data) {
        if (data) {
            for (let i = 0; i <= data.length && data[i] !== undefined; i++) {
                let $moreItems = $(IllustrationItemTemplate.render({
                    illustration: data[i],
                    language: window.app.settings.language
                }));

                if ($moreItems[0].children[1].children.length > 0
                    && $moreItems[0].children[1].children[0].nodeName === 'SPAN') {
                    $moreItems[0].children[1].children[0].innerHTML = '';
                }

                this.$moreContent.append($moreItems);
            }

            this.count += data.length;
            this.observer.observe();
            this.onResize();

            if (this.allCount <= this.count) {
                this.$more.addClass('hidden');
            }
        }
    }

    onKeySearch(e) {
        if ($(e)[0].keyCode === 37 || $(e)[0].keyCode === 39) {
            return;
        }

        this.value = $(e.currentTarget)[0].value;
        if (this.value === '') {
            this.$selectPopup.removeClass('open');
            this.$selectPopupWrapper.children().remove();
        } else {
            // load everything by coincidence with value from input
            axios.get(Urls['front:api:illustrations-search-tokens'](), {
                params: {
                    value: String(this.value),
                    language: window.app.settings.language
                }
            })
                .then(response => {
                    this.onLoadPopup(response?.data);

                    this.$selectPopup.addClass('open');
                })
                .catch(() => {
                    this.$selectPopupWrapper.children().remove();
                });
        }
    }
}
